export default __webpack_public_path__ + "static/lili-flip-a7d4afee0e287af4421d6251f33271f9.jpg";